import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30fa4b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "携わったことのある"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "クライアント業種を教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "携わったことのあるクライアント業種（複数選択可）")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_1" }
const _hoisted_8 = {
  key: 0,
  class: "entry_career_input"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "その他")
], -1))
const _hoisted_10 = { class: "entry_career_input_layout_column_1" }
const _hoisted_11 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_12 = { class: "entry_career_button" }
const _hoisted_13 = { class: "entry_career_button_prev" }
const _hoisted_14 = { class: "entry_career_button_next" }
const _hoisted_15 = { class: "entry_career_skip" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Indicator from '@/components/Indicator.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import Loading from '@/components/Loading.vue';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import { getExepInds, putExepInds } from '@/api/careersheetEndpoint';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillbusinesstypeView',
  setup(__props) {

const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    const res = await getExepInds();
    fashionFlg.value = res.fashionFlg || false;
    foodFieldFlg.value = res.foodFieldFlg || false;
    realEstateFieldFlg.value = res.realEstateFieldFlg || false;
    articlesFieldFlg.value = res.articlesFieldFlg || false;
    cosmeticsToiletryFieldFlg.value = res.cosmeticsToiletryFieldFlg || false;
    medicalFieldFlg.value = res.medicalFieldFlg || false;
    automobileFieldFlg.value = res.automobileFieldFlg || false;
    itFieldFlg.value = res.itFieldFlg || false;
    electronicsFieldFlg.value = res.electronicsFieldFlg || false;
    precisionEquipmentOfficeSuppliesFlg.value = res.precisionEquipmentOfficeSuppliesFlg || false;
    retailFieldFlg.value = res.retailFieldFlg || false;
    financingInsuranceSecuritiesFlg.value = res.financingInsuranceSecuritiesFlg || false;
    sportsFieldFlg.value = res.sportsFieldFlg || false;
    foodServiceFieldFlg.value = res.foodServiceFieldFlg || false;
    beautyHealthFieldFlg.value = res.beautyHealthFieldFlg || false;
    entertainmentFieldFlg.value = res.entertainmentFieldFlg || false;
    transportationSightseeingAmusementFlg.value = res.transportationSightseeingAmusementFlg || false;
    publicationFieldFlg.value = res.publicationFieldFlg || false;
    schoolEducationFieldFlg.value = res.schoolEducationFieldFlg || false;
    mailOrderFieldFlg.value = res.mailOrderFieldFlg || false;
    governmentAdministrationFieldFlg.value = res.governmentAdministrationFieldFlg || false;
    otherFieldFlg.value = res.otherFieldFlg || false;
    otherFieldMemo.value = res.otherFieldMemo || '';
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const fashionFlg = ref(false);
const foodFieldFlg = ref(false);
const realEstateFieldFlg = ref(false);
const articlesFieldFlg = ref(false);
const cosmeticsToiletryFieldFlg = ref(false);
const medicalFieldFlg = ref(false);
const automobileFieldFlg = ref(false);
const itFieldFlg = ref(false);
const electronicsFieldFlg = ref(false);
const precisionEquipmentOfficeSuppliesFlg = ref(false);
const retailFieldFlg = ref(false);
const financingInsuranceSecuritiesFlg = ref(false);
const sportsFieldFlg = ref(false);
const foodServiceFieldFlg = ref(false);
const beautyHealthFieldFlg = ref(false);
const entertainmentFieldFlg = ref(false);
const transportationSightseeingAmusementFlg = ref(false);
const publicationFieldFlg = ref(false);
const schoolEducationFieldFlg = ref(false);
const mailOrderFieldFlg = ref(false);
const governmentAdministrationFieldFlg = ref(false);
const otherFieldFlg = ref(false);

const schema = object({
  otherFieldMemo: string().label('その他詳細').max(100, VALIDATON_ERRORS.MAX_LENGTH),
});
const { meta, errors } = useForm({
  validationSchema: schema,
});
const { value: otherFieldMemo } = useField('otherFieldMemo', undefined, {
  initialValue: '',
});

const exepIndsList = ref([
  { label: 'ファッション', value: fashionFlg },
  { label: '食品・飲料・酒類', value: foodFieldFlg },
  { label: '不動産・住宅・設備', value: realEstateFieldFlg },
  { label: '家庭用品・雑品', value: articlesFieldFlg },
  { label: '化粧品・トイレタリー', value: cosmeticsToiletryFieldFlg },
  { label: '医療品・医療用品', value: medicalFieldFlg },
  { label: '自動車・関連用品', value: automobileFieldFlg },
  { label: 'IT（通信・情報）関連', value: itFieldFlg },
  { label: '家電・AV機器', value: electronicsFieldFlg },
  { label: '精密機器・事務用品', value: precisionEquipmentOfficeSuppliesFlg },
  { label: '流通・小売業', value: retailFieldFlg },
  { label: '金融・保険・証券', value: financingInsuranceSecuritiesFlg },
  { label: '趣味・スポーツ関連', value: sportsFieldFlg },
  { label: '外食・各種サービス', value: foodServiceFieldFlg },
  { label: '美容・健康', value: beautyHealthFieldFlg },
  { label: 'エンターテイメント', value: entertainmentFieldFlg },
  { label: '運輸・観光・娯楽', value: transportationSightseeingAmusementFlg },
  { label: '出版', value: publicationFieldFlg },
  { label: '学校・教育関連', value: schoolEducationFieldFlg },
  { label: '通信販売・訪問販売', value: mailOrderFieldFlg },
  { label: '官公庁・団体', value: governmentAdministrationFieldFlg },
  { label: 'その他', value: otherFieldFlg },
]);

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c11' });
};
const submit = async () => {
  isLoading.value = true;
  try {
    await putExepInds({
      fashionFlg: fashionFlg.value,
      foodFieldFlg: foodFieldFlg.value,
      realEstateFieldFlg: realEstateFieldFlg.value,
      articlesFieldFlg: articlesFieldFlg.value,
      cosmeticsToiletryFieldFlg: cosmeticsToiletryFieldFlg.value,
      medicalFieldFlg: medicalFieldFlg.value,
      automobileFieldFlg: automobileFieldFlg.value,
      itFieldFlg: itFieldFlg.value,
      electronicsFieldFlg: electronicsFieldFlg.value,
      precisionEquipmentOfficeSuppliesFlg: precisionEquipmentOfficeSuppliesFlg.value,
      retailFieldFlg: retailFieldFlg.value,
      financingInsuranceSecuritiesFlg: financingInsuranceSecuritiesFlg.value,
      sportsFieldFlg: sportsFieldFlg.value,
      foodServiceFieldFlg: foodServiceFieldFlg.value,
      beautyHealthFieldFlg: beautyHealthFieldFlg.value,
      entertainmentFieldFlg: entertainmentFieldFlg.value,
      transportationSightseeingAmusementFlg: transportationSightseeingAmusementFlg.value,
      publicationFieldFlg: publicationFieldFlg.value,
      schoolEducationFieldFlg: schoolEducationFieldFlg.value,
      mailOrderFieldFlg: mailOrderFieldFlg.value,
      governmentAdministrationFieldFlg: governmentAdministrationFieldFlg.value,
      otherFieldFlg: otherFieldFlg.value,
      otherFieldMemo: otherFieldFlg.value && otherFieldMemo.value ? otherFieldMemo.value : '',
    });
    router.push({ name: 'c14' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 11,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exepIndsList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "entry_career_input_layout_column_1_item"
            }, [
              _createVNode(BaseCheckbox, {
                value: false,
                label: item.label,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ])
      ]),
      (otherFieldFlg.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(BaseTextareaForm, {
                  modelValue: _unref(otherFieldMemo),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(otherFieldMemo) ? (otherFieldMemo).value = $event : null)),
                  name: "otherFieldMemo",
                  rows: 3,
                  maxCount: 100,
                  placeholder: "その他の場合、詳細を入力してください"
                }, null, 8, ["modelValue"]),
                (_unref(errors).otherFieldMemo)
                  ? (_openBlock(), _createBlock(ErrorMessage, {
                      key: 0,
                      errors: [_unref(errors).otherFieldMemo]
                    }, null, 8, ["errors"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseButton, {
            onClick: submit,
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存して次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})